import { useRef, useEffect, useCallback } from "react";
import { invokeFnAsync } from "../../utils/invokeFn.js";
function useDebounced(fn, waitMs, options = {}) {
  const { deps = [] } = options, argsRef = useRef(), timeout = useRef();
  function cleanup() {
    timeout.current && clearTimeout(timeout.current);
  }
  return useEffect(function() {
    return cleanup;
  }, []), useCallback(
    async function(...args) {
      argsRef.current = args, cleanup(), timeout.current = setTimeout(async function() {
        await invokeFnAsync(fn, argsRef.current);
      }, waitMs);
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps --
     *   We want to allow the caller to have control over `deps` so they can decide
     *     when this function has actually changed
     */
    [fn, waitMs, ...deps]
  );
}
export {
  useDebounced
};
//# sourceMappingURL=useDebounced.js.map
